import { useEffect } from 'react'
import { useNavigation } from './useNavigation'
import { getCurrentFolderPathFromHash, onHashChange } from '@/utils/hashNavigation'

/**
 * Hook to handle hash-based folder navigation
 * - Listens for hash changes and navigates to the corresponding folder
 * - Handles initial navigation on page load/refresh
 */
export function useHashNavigation() {
  const { folderTree, navigateToFolderFromHash } = useNavigation()

  // Handle initial navigation from hash on component mount
  useEffect(() => {
    if (folderTree.length > 0) {
      const currentPath = getCurrentFolderPathFromHash()
      if (currentPath && currentPath !== '/') {
        navigateToFolderFromHash(currentPath)
      }
    }
  }, [folderTree, navigateToFolderFromHash])

  // Listen for hash changes
  useEffect(() => {
    const cleanup = onHashChange((folderPath) => {
      if (folderTree.length > 0) {
        navigateToFolderFromHash(folderPath)
      }
    })

    return cleanup
  }, [folderTree, navigateToFolderFromHash])
}
